// @flow
import { withRouter as reactRouterWithRouter } from 'react-router';
import { type RouterProps } from './RouterProps';

export default function withRouter<MatchParams: {}, Props: RouterProps<MatchParams>>(
  Component: React$ComponentType<Props>
): React$ComponentType<$Diff<Props, RouterProps<MatchParams>>> {
  return (((reactRouterWithRouter(Component)): any): React$ComponentType<$Diff<Props, RouterProps<MatchParams>>>);
}
